import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=7c94e07c"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryInformation.vue?vue&type=style&index=0&id=7c94e07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports